import { render, staticRenderFns } from "./waiver-of-appeal-request.vue?vue&type=template&id=5722d56d&scoped=true&"
import script from "./waiver-of-appeal-request.vue?vue&type=script&lang=js&"
export * from "./waiver-of-appeal-request.vue?vue&type=script&lang=js&"
import style0 from "./waiver-of-appeal-request.vue?vue&type=style&index=0&id=5722d56d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722d56d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
